import { BookStatuses, TBookAbbrvs } from '../../types/index';
export { default as logBookClick } from './logBookClick';
export { logBookLoginResponse, logBookLoginSubmit } from './logBookLogin';
export { default as logClickCreate } from './logClickCreate';
export { default as logClickLink } from './logClickLink';
export { default as logClickSecurityMessageContinue } from './logClickSecurityMessageContinue';
export { default as logContextFetchError } from './logContextFetchError';
export { default as logErrorData } from './logErrorData';
export { default as logFetchError } from './logFetchError';
export { default as logLoadContext } from './logLoadContext';
export { default as logOpenAffiliateLink } from './logOpenAffiliateLink';
export { default as logRedirect } from './logRedirect';
export { default as logRedirectStandalone } from './logRedirectStandalone';
export { default as logUnsupported } from './logUnsupported';
export { default as logUrlError } from './logUrlError';

/*
|--------------------------------------------------------------------------
| Types
|--------------------------------------------------------------------------
*/

export interface IUserLog {
    id: number;
    name: string;
}

export interface IBookLog {
    id: string;
    abbr: TBookAbbrvs;
    name: string;
    status: BookStatuses;
}

export interface IBookRegionLog {
    id: string | null;
    abbr: string;
    name: string;
    isCountry: boolean;
    status: BookStatuses | null;
}

/*
|--------------------------------------------------------------------------
| Util Methods
|--------------------------------------------------------------------------
*/

// removes the identifier from the string
// eg: /link/login/b3/BSTA_imNzJpQvRWuKIYd7FwWjgw -> /link/login/b3/BSTA
export const removeUrlIdentifier = (url: string): string => {
    return url
        .split('/')
        .map((str) => str.split('_')[0])
        .join('/');
};

export const getRequestData = () => {
    return {
        request: {
            full_path: window.location.href,
            url: removeUrlIdentifier(window.location.href),
        },
    };
};

export const formatUserData = (userLog: IUserLog) => {
    return {
        user: userLog.name,
        userId: userLog.id,
    };
};
